import { render, staticRenderFns } from "./TipJarIntegration.vue?vue&type=template&id=8a5f17b4&scoped=true&"
import script from "./TipJarIntegration.vue?vue&type=script&lang=ts&"
export * from "./TipJarIntegration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5f17b4",
  null
  
)

export default component.exports